// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.cald_dist-side-panel-desc, .cald_side-panel-content .sidebar .nameCls, .cald_side-panel-content .cc_menu_indicator {
  font-family: "72-Regular";
}

.global-side-panel-content {
  width: 24rem;
  overflow: hidden;
  height: 100%;
}
.global-side-panel-content [class^=icon-]:before, .global-side-panel-content [class*=" icon-"]:before {
  font-size: 1.6rem;
  color: #313336;
}

.cald_side-panel-content {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 5rem);
}
.cald_side-panel-content .active-item {
  background-color: rgba(18, 120, 221, 0.1);
  border-left: 0.2rem solid #1278dd;
}
.cald_side-panel-content .cc_menu_indicator {
  width: 2rem;
  padding: 0rem;
  text-align: center;
  background-color: #2797e0;
  border-radius: 50%;
  position: absolute;
  color: #fff !important;
  font-size: 1rem;
  top: 0;
  left: 9%;
}
.cald_side-panel-content .sidebar .sidebar-nav {
  position: relative;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.cald_side-panel-content .sidebar-nav {
  transition: width 0.25s;
}
.cald_side-panel-content .sidebar .nav {
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.cald_side-panel-content .sidebar .nav-item {
  width: 25rem;
  overflow: hidden;
  line-height: 1.7rem;
}
.cald_side-panel-content .sidebar .nav-item .nav-item {
  line-height: 1rem;
}
.cald_side-panel-content .sidebar .nav-link, .cald_side-panel-content .sub-nav-link {
  display: block;
  padding: 1rem 1.4rem;
  text-decoration: none;
  position: relative;
  margin: 0;
  white-space: nowrap;
}
.cald_side-panel-content .sidebar .nav-link span, .cald_side-panel-content .sub-nav-link span {
  color: #2f3c48;
  font-size: 1.4rem;
}
.cald_side-panel-content .sidebar .nav-link:hover, .cald_side-panel-content .sub-nav-link:hover {
  background-color: rgba(18, 120, 221, 0.05);
}
.cald_side-panel-content .sidebar .nav-link .menu-icon, .cald_side-panel-content .sub-nav-link .menu-icon {
  padding-right: 1.4rem;
}
.cald_side-panel-content .sub-nav-link {
  padding: 0.7rem 1.4rem;
}
.cald_side-panel-content .sub-nav-link:hover {
  background-color: rgba(18, 120, 221, 0.05);
}
.cald_side-panel-content #sub_nav_dropdown_list {
  margin-left: 16rem;
}
.cald_side-panel-content .sidebar .nav-dropdown-items {
  position: fixed;
  list-style: none;
  padding-left: 0;
  margin-left: 4.8rem;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);
  margin-top: -1.2rem;
}
.cald_side-panel-content .sidebar .nav-dropdown-items li:hover {
  background-color: rgba(18, 120, 221, 0.1);
}
.cald_side-panel-content .sidebar .nav-link em {
  width: 24rem;
  display: inline-block;
  color: rgba(81, 110, 127, 0.7);
}
.cald_side-panel-content .sidebar .nameCls {
  position: fixed;
  left: 4.8rem;
  margin-top: -1rem;
  width: 25rem;
  padding: 1.1rem 1.5rem 0.7rem;
  border-bottom: 0.1rem solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);
  color: #6a6d70 !important;
  font-size: 1.2rem !important;
}
.cald_side-panel-content .no-children-header .nameCls {
  padding: 1.5rem;
  border-bottom: none;
}

.cald_side-panel-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, 0.3);
  border-radius: 1rem;
}

.cald_side-panel-content::-webkit-scrollbar {
  width: 0.4rem;
}

.cald_side-panel-content::-webkit-scrollbar-thumb {
  border-radius: 1rem;
  box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, 0.3);
  background-color: rgb(240, 244, 246);
}

.cald_dist-panel-icon {
  font-size: 1.8rem;
  padding-right: 1.4rem;
  color: #313336;
  display: inline-block;
  cursor: pointer;
}

.cald_dist-panel-sub-icon {
  font-size: 1.8rem;
  padding: 0.7rem 1rem;
  color: rgba(81, 110, 127, 0.3);
  width: 4rem;
  cursor: pointer;
}

.cald_dist-panel-nav-icon {
  font-size: 1.8rem;
  padding: 1.5rem;
  color: rgba(81, 110, 127, 0.7);
  width: 4.5rem;
  display: inline-block;
  cursor: pointer;
}

.app-version {
  display: flex;
  justify-content: space-between;
  padding-left: 1.5rem;
}
.app-version .app-version-text {
  align-self: center;
}

.cald_dist-side-panel-desc {
  font-size: 1.4rem;
  letter-spacing: 0;
  text-align: left;
  color: #313336;
}
.cald_dist-side-panel-desc .menu-without-sub-menus {
  padding: 1.1rem 1.4rem;
}
.cald_dist-side-panel-desc .menu-without-sub-menus:hover {
  background-color: rgba(10, 110, 209, 0.05);
}
.cald_dist-side-panel-desc .cald_panel-group .expanded-menu {
  background-color: rgba(18, 120, 221, 0.05);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-heading {
  display: inline-block;
  width: 100%;
  padding: 1.1rem 1.4rem;
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-heading .cald_panel-title {
  display: inline-block;
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-heading:hover {
  background-color: rgba(10, 110, 209, 0.05);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-selected {
  background-color: rgba(18, 120, 221, 0.1);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-selected .cald_dist-panel-sub-icon {
  color: rgba(81, 110, 127, 0.7);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_arrow-icon {
  color: rgba(81, 110, 127, 0.7);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_list-group-item-selected {
  background-color: rgba(18, 120, 221, 0.1);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_list-group-item-selected .cald_dist-panel-sub-icon {
  color: rgba(81, 110, 127, 0.7);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse {
  overflow: hidden;
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse .cald_list-group {
  list-style: none;
  padding: 0rem 0;
  margin: 0;
  width: 100%;
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse .cald_list-group .cald_list-group-item {
  letter-spacing: 0;
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse .cald_list-group .cald_list-group-item:hover {
  background-color: rgba(10, 110, 209, 0.05);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse .cald_list-group .cald_list-group-item:hover .cald_dist-panel-sub-icon {
  color: rgba(81, 110, 127, 0.7);
}
.cald_dist-side-panel-desc .cald_panel-group .cald_panel-collapse .cald_list-group .cald_list-group-item .sub-menu-item {
  display: inline-block;
  font-size: 1.2rem;
  color: #313336;
  padding: 0.8rem 4.7rem;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}

.sub-nav-dropdown-items {
  margin-left: 25rem !important;
  margin-top: -3rem !important;
  height: calc(100vh - 60rem) !important;
  overflow: auto !important;
  max-height: -moz-fit-content !important;
  max-height: fit-content !important;
}

.cald-logout-menu {
  margin-left: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/side-menu/side-menu.component.scss","webpack://./src/app/assets/css/_variables.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AAFA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AAKF;AAJE;EACE,iBAAA;EACA,cCwBiB;ADlBrB;;AAFA;EAmBE,gBAAA;EACA,kBAAA;EACA,yBAAA;AAbF;AAPE;EACE,yCAAA;EACA,iCAAA;AASJ;AAPE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,eAAA;EACA,MAAA;EACA,QAAA;AAQJ;AADE;EACE,kBAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;AAGJ;AADE;EACE,uBAAA;AAGJ;AAAE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;AACE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAAI;EACE,iBAAA;AAEN;AACE;EACE,cAAA;EACA,oBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAEI;EACE,cAAA;EACA,iBAAA;AAAN;AAEI;EACE,0CAAA;AAAN;AAEI;EACE,qBAAA;AAAN;AAKE;EACE,sBAAA;AAHJ;AAOI;EACE,0CAAA;AALN;AAQE;EACE,kBAAA;AANJ;AAQE;EACE,eAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,sBAAA;EACA,6CAAA;EACA,mBAAA;AARJ;AAUI;EAEE,yCAAA;AATN;AAYE;EACE,YAAA;EACA,qBAAA;EACA,8BAAA;AAVJ;AAaE;EAEE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,mCAAA;EAEA,sBAAA;EACA,6CAAA;EACA,yBAAA;EACA,4BAAA;AAbJ;AAgBI;EACE,eAAA;EACA,mBAAA;AAdN;;AAoBA;EAEE,+CAAA;EACA,mBAAA;AAjBF;;AAmBA;EACE,aAAA;AAhBF;;AAkBA;EACE,mBAAA;EAEA,+CAAA;EACA,oCAAA;AAfF;;AA6BA;EACE,iBAAA;EAEA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,oBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AA3BF;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AA9BF;AA+BE;EACE,kBAAA;AA7BJ;;AAiCA;EACE,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,cAAA;AA/BF;AAgCE;EACE,sBAAA;AA9BJ;AA+BI;EACE,0CAAA;AA7BN;AAoCI;EAEE,0CAAA;AAnCN;AAqCI;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;AAnCN;AAoCM;EACE,qBAAA;AAlCR;AAqCM;EACE,0CAAA;AAnCR;AAsCI;EACE,yCAAA;AApCN;AAqCM;EACE,8BAAA;AAnCR;AAsCI;EACE,8BAAA;AApCN;AAsCI;EACE,yCAAA;AApCN;AAqCM;EACE,8BAAA;AAnCR;AAsCI;EACE,gBAAA;AApCN;AAqCM;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EAEA,WAAA;AApCR;AAqCQ;EACE,iBAAA;AAnCV;AAoCU;EAEE,0CAAA;AAnCZ;AAoCY;EACE,8BAAA;AAlCd;AAqCU;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AAnCZ;;AA2CA;EACE,6BAAA;EACA,4BAAA;EACA,sCAAA;EACA,yBAAA;EACA,uCAAA;EAAA,kCAAA;AAxCF;;AA2CA;EACE,iBAAA;AAxCF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts'; \n.global-side-panel-content {\n  width: 24rem;\n  overflow: hidden;\n  height: 100%;\n  [class^=\"icon-\"]:before, [class*=\" icon-\"]:before {\n    font-size: 1.6rem;\n    color: $sidebar-icon-color;\n  }\n}\n\n.cald_side-panel-content {\n  .active-item {\n    background-color: rgba(18, 120, 221, 0.1);\n    border-left: 0.2rem solid #1278dd;\n  }\n  .cc_menu_indicator{\n    width: 2rem;\n    padding: 0rem;\n    text-align: center;\n    background-color: #2797e0;\n    border-radius: 50%;\n    position: absolute;\n    color: #fff !important;\n    @extend %font-regular;\n    font-size: 1rem;\n    top: 0;\n    left: 9%;\n  }\n  // box-shadow: 1px 0 1px 0 rgba(108, 147, 170, 0.6);\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(100% - 5rem);\n\n  .sidebar .sidebar-nav {\n    position: relative;\n    flex: 1;\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n  .sidebar-nav {\n    transition: width .25s;\n  }\n\n  .sidebar .nav {\n    flex-direction: column;\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n  }\n\n  .sidebar .nav-item {\n    width: 25rem;\n    overflow: hidden;\n    line-height: 1.7rem;\n    .nav-item{\n      line-height: 1rem;\n    }\n  }\n  .sidebar .nav-link, .sub-nav-link {\n    display: block;\n    padding: 1rem 1.4rem;\n    text-decoration: none;\n    // background: rgba(199, 221, 237, 0.2);\n    position: relative;\n    margin: 0;\n    white-space: nowrap;\n    //border-left: 0 !important;\n    span {\n      color: #2f3c48;\n      font-size: 1.4rem;\n    }\n    &:hover {\n      background-color: rgba(18, 120, 221, 0.05);\n    }\n    .menu-icon{\n      padding-right: 1.4rem;\n    }\n    \n  }\n\n  .sub-nav-link{\n    padding: 0.7rem 1.4rem;\n  }\n\n  .sub-nav-link {\n    &:hover {\n      background-color: rgba(18, 120, 221, 0.05);\n    }\n  }\n  #sub_nav_dropdown_list{\n    margin-left: 16rem;\n  }\n  .sidebar .nav-dropdown-items {\n    position: fixed;\n    // left: 1rem;\n    list-style: none;\n    padding-left: 0;\n    margin-left: 4.8rem;\n    // background-color: #f0f4f7;\n    background-color: #fff;\n    box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);\n    margin-top: -1.2rem;\n\n    li:hover {\n      // background-color:rgba(199, 221, 237, 1);\n      background-color: rgba(18, 120, 221, 0.1);\n    }\n  }\n  .sidebar .nav-link em{\n    width: 24rem;\n    display: inline-block;\n    color: rgba(81, 110, 127, 0.7);\n  }\n\n  .sidebar .nameCls {\n    @extend %font-regular;\n    position: fixed;\n    left: 4.8rem;\n    margin-top: -1rem;\n    width: 25rem;\n    padding: 1.1rem 1.5rem 0.7rem;\n    border-bottom: 0.1rem solid #e5e5e5;\n    // background-color: rgba(199, 221, 237, 1);\n    background-color: #fff;\n    box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);\n    color: #6a6d70 !important;\n    font-size: 1.2rem !important;\n  }\n  .no-children-header{\n    .nameCls{\n      padding: 1.5rem;\n      border-bottom: none;\n    }\n  }\n  \n}\n\n.cald_side-panel-content::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, 0.3);\n  box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, 0.3);\n  border-radius: 1rem;\n}\n.cald_side-panel-content::-webkit-scrollbar {\n  width: 0.4rem;\n}\n.cald_side-panel-content::-webkit-scrollbar-thumb {\n  border-radius: 1rem;\n  -webkit-box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, .3);\n  box-shadow: inset 0 0 0.6rem rgba(0, 0, 0, 0.3);\n  background-color: rgb(240, 244, 246);\n}\n\n// .each-menu-item {\n//   .menu-icon {\n//     font-size: 1.8rem;\n//     // padding: 0.7rem 1rem;\n//     padding-right: 1.4rem;\n//     color: rgba(81, 110, 127, 0.7);\n//     width: 5rem;\n//     cursor: pointer;\n//   }\n// }\n\n.cald_dist-panel-icon {\n  font-size: 1.8rem;\n  // padding: 0.7rem 1.4rem;\n  padding-right: 1.4rem;\n  color: #313336;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.cald_dist-panel-sub-icon{\n  font-size: 1.8rem;\n  padding: 0.7rem 1rem;\n  color: rgba(81, 110, 127, 0.3);\n  width: 4rem;\n  cursor: pointer;\n}\n\n.cald_dist-panel-nav-icon{\n  font-size: 1.8rem;\n  padding: 1.5rem;\n  color: rgba(81, 110, 127, 0.7);\n  width: 4.5rem;\n  display: inline-block;\n  cursor: pointer;\n}\n\n// .cald_dist-side-panel-nav {\n//   background-color: rgba(199, 221, 237, 0.3);\n// }\n.app-version {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 1.5rem;\n  .app-version-text {\n    align-self: center;\n  }\n}\n\n.cald_dist-side-panel-desc {\n  font-size: 1.4rem;\n  @extend %font-regular;\n  letter-spacing: 0;\n  text-align: left;\n  color: #313336;\n  .menu-without-sub-menus {\n    padding: 1.1rem 1.4rem;\n    &:hover {\n      background-color: rgba(10, 110, 209, 0.05);\n    }\n    // &[class*=\"Bookmarks\"] {\n    //   border-bottom: solid 0.1rem #9b9b9b;\n    // }\n  }\n  .cald_panel-group {\n    .expanded-menu {\n      // background-color: rgba(199, 221, 237, 0.05);\n      background-color: rgba(18, 120, 221, 0.05);\n    }\n    .cald_panel-heading {\n      display: inline-block;\n      width: 100%;\n      padding: 1.1rem 1.4rem;\n      .cald_panel-title {\n        display: inline-block;\n        // width: 70%;\n      }\n      &:hover {\n        background-color: rgba(10, 110, 209, 0.05);\n      }\n    }\n    .cald_panel-selected {\n      background-color: rgba(18, 120, 221, 0.1);\n      .cald_dist-panel-sub-icon{\n        color: rgba(81, 110, 127, 0.7);\n      }\n    }\n    .cald_arrow-icon {\n      color: rgba(81, 110, 127, 0.7);\n    }\n    .cald_list-group-item-selected{\n      background-color: rgba(18, 120, 221, 0.1);\n      .cald_dist-panel-sub-icon{\n        color: rgba(81, 110, 127, 0.7);\n      }\n    }\n    .cald_panel-collapse {\n      overflow: hidden; // scroll-behavior:none;\n      .cald_list-group {\n        list-style: none;\n        padding: 0rem 0;\n        margin: 0;\n        // background-color: rgba(18, 120, 221, 0.1);\n        width: 100%;\n        .cald_list-group-item {\n          letter-spacing: 0;\n          &:hover {\n            // background-color: rgba(199, 221, 237, 1);\n            background-color: rgba(10, 110, 209, 0.05);\n            .cald_dist-panel-sub-icon{\n              color: rgba(81, 110, 127, 0.7);\n            }\n          }\n          .sub-menu-item {\n            display: inline-block;\n            font-size: 1.2rem;\n            color: #313336;\n            padding: 0.8rem 4.7rem;\n            text-overflow: ellipsis;\n            width: 100%;\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n  }\n}\n\n.sub-nav-dropdown-items {\n  margin-left: 25rem !important;\n  margin-top: -3rem !important;\n  height: calc(100vh - 60rem) !important;\n  overflow: auto !important;\n  max-height: fit-content !important;\n}\n\n.cald-logout-menu {\n  margin-left: 4rem;\n}","$label-color: #6f7275;\n$label-value: #515559;\n$title-color: #32363a;\n$actions-color: #0a6ed1;\n$bg-color: #edeff0;\n$white: #fff;\n$shell-bg-color: #354a5f;\n$nav-bg-color:#F8F9FA;\n$placeholder-image-bg-color: #eeeeef;\n$text-action-hover-color: #fafafa;\n$text-action-click-color: #eeeeef;\n$active-input-color: #eef5fc;\n$error-color: #ee0000;\n$warning-offline-color: #e9730c;\n$success-color: #118843;\n$input-text-color: #32363a;\n$form-field-disable-color: #fafafa;\n$divider-color: #e5e5e5;\n$warning-bg-color:#fef7f1;\n$danger-color: #bb0000;\n$green-text: #107f3e;\n\n// buttons\n$primary-btn-color: #0a6ed1;\n$primary-btn-hover-color: #085caf;\n$primary-btn-active-color: #0854a1;\n$primary-btn-border-color: #367db8;\n$toggle-down-color: #0854a1;\n$shell-icon-color: #d1e3ff;\n$shell-hover-color: #485b6e;\n$shell-icon-active-color: #919ba7;\n$sidebar-icon-color: #313336;\n\n//Bootstrap5 migration\n$btn-primary-color: #337ab7;\n$btn-primary-active-color: #2e6da4;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
